import vueAuthInstance from '@/services/auth.js'

export default {
  state: {
    uid: null,
    eid: window.localStorage.getItem('eid') || null,
    isAuthenticated: vueAuthInstance?.isAuthenticated() || false
  },
  getters: {
    isAuthenticated: state => {
      return state.isAuthenticated
    },
    uid: state => {
      return state.uid
    },
    eid: state => {
      return state.eid
    }
  },
  mutations: {
    isAuthenticated: (state, payload) => {
      state.isAuthenticated = payload.isAuthenticated
    },
    setUid: (state, uid) => {
      state.uid = uid
    },
    setEid: (state, eid) => {
      window.localStorage.setItem('eid', eid)
      state.eid = eid
    }
  },
  actions: {
    login({ commit }, payload) {
      payload = payload || {}
      return vueAuthInstance.login(payload.user, payload.requestOptions)
        .then(response => {
          commit('isAuthenticated', {
            isAuthenticated: vueAuthInstance.isAuthenticated()
          })
          const uid = vueAuthInstance.getPayload() ? vueAuthInstance.getPayload().sub : null
          commit('setUid', uid)
          if (response.body.ecosystem_id) {
            commit('setEid', response.body.ecosystem_id)
          }

          // Set app roles after being authorized
          commit('setAppRoles', {
            params: {
              sort: [{
                key: 'name',
                direction: 'asc'
              }]
            }
          })
        })
    },
    register({ commit }, payload) {
      payload = payload || {}
      return vueAuthInstance.register(payload.user, payload.requestOptions)
        .then(() => {
          commit('isAuthenticated', {
            isAuthenticated: vueAuthInstance.isAuthenticated()
          })
        })
    },
    logout({ commit }, payload) {
      payload = payload || {}
      payload.requestOptions = vueAuthInstance.options
      return vueAuthInstance.logout(payload.requestOptions)
        .then(() => {
          commit('setUid', null)
          commit('setProfile', {})
          commit('setRoles', [])
          commit('isAuthenticated', {
            isAuthenticated: vueAuthInstance.isAuthenticated()
          })
        })
    },
    authenticate: ({ commit }, payload) => {
      payload = payload || {}
      return vueAuthInstance.authenticate(payload.provider, payload.userData, payload.requestOptions)
        .then(() => {
          commit('isAuthenticated', {
            isAuthenticated: vueAuthInstance.isAuthenticated()
          })
        })
    }
  }
}
